import Vue from 'vue'
import { normalize, schema } from 'normalizr'
import {
  RECEIVE_LEDGERITEMS,
  RECEIVING_LEDGERITEMS,
  RECEIVE_LEDGER_METADATA,
  RECEIVE_LEDGERITEM_FAILURE,
  CLEAR_LEDGER_STATE,
  CLEAR_STATE
} from '../mutationTypes'
import { checkStatus, getHeaders, parseJSON, buildUrlWithQuery } from '@/utils/api'
import handleXHRError from '@/utils/helpers/HandleXHRError'

const ledgerSchema = new schema.Entity('ledger')
const ledgerListSchema = new schema.Array(ledgerSchema)

const state = {
  data: {},
  cache: {},
  count: null,
  shown: null,
  next: null,
  previous: null,
  receivingData: false,
  receiveDataFailure: false,
  currentPage: 1
}

const actions = {
  // DEPRECATED
  fetchLedgersWithQuery (store, query) {
    const instanceUrl = this.getters.getActiveInstance.url
    const headers = getHeaders(this.getters.getToken)
    this.commit(RECEIVING_LEDGERITEMS, true)
    return Vue.http.get(buildUrlWithQuery('ledger', query, instanceUrl), { headers })
      .then(checkStatus)
      .then(parseJSON)
      .then(r => {
        this.commit(RECEIVING_LEDGERITEMS, false)
        if (r.hasOwnProperty('results')) {
          const { results, next, previous, count } = r
          const { entities, result } = normalize(results, ledgerListSchema)
          this.commit(RECEIVE_LEDGERITEMS, !result || !result.length ? results : entities.ledger)
          this.commit(RECEIVE_LEDGER_METADATA, { next, previous, count, result: result.length })
          return { query, count, entities }
        }
      })
      .catch(e => {
        this.commit(RECEIVING_LEDGERITEMS, false)
        this.commit(RECEIVE_LEDGERITEM_FAILURE, handleXHRError(e))
      })
  }
}

const getters = {
  getLedger: (state) => {
    return state.data ? Object.values(state.data).map(v => Object.assign({}, v)) : []
  },
  getLedgerMetadata: (state) => {
    const { data, count } = state
    if (!data || !Object.keys(data).length) {
      return { count: 0, shown: 0 }
    }
    return { count, shown: Object.keys(data).length }
  },
  getLedgerFetchStatus: (state) => {
    return state.receivingData
  }
}

const mutations = {
  [RECEIVE_LEDGERITEMS] (state, results) {
    const { page, data } = results
    if (!data || !Object.keys(data).length) return state.data
    for (let d in data) {
      if (!state.cache[d] || !state.cache[d].page) data[d]['page'] = page || 1
    }
    state.currentPage = page || 1
    state.cache = Object.assign({}, state.cache, data)
    if (state.data && Object.keys(state.data).length) {
      state.data = Object.assign({}, state.data, data)
    } else {
      state.data = data
    }
  },
  [RECEIVING_LEDGERITEMS] (state, payload) {
    state.receivingData = payload
  },
  [RECEIVE_LEDGERITEM_FAILURE] (state, error) {
    state.receiveDataFailure = error
  },
  [RECEIVE_LEDGER_METADATA] (state, payload) {
    if (payload) {
      const { page, count, next, previous, result } = payload
      if (page) state.currentPage = page
      if (count) state.count = count
      if (result) state.shown = result
      if (next) state.next = next
      if (previous) state.previous = previous
    } else if (state.data) {
      state.count = Object.keys(state.data).length
    }
  },
  [CLEAR_LEDGER_STATE] (state) {
    state.data = Object.assign({})
    state.cache = Object.assign({})
    state.receivingData = false
    state.receiveDataFailure = false
  },
  [CLEAR_STATE] (state) {
    state.data = Object.assign({})
    state.count = null
    state.shown = null
    state.next = null
    state.previous = null
    state.currentPage = 1
    state.receivingData = false
    state.receiveDataFailure = false
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/ledger.js